/**
 * Routine Expand — Arc-to-Vertical (mobile) / Card reveal (desktop)
 *
 * Mobile: Click → loading dots (2s) → arc morphs to vertical list with skeleton → real cards
 * Desktop: Click → loading dots (1.5s) → skeleton cards (1.2s) → real cards slide in
 *
 * CSS classes driven by this script:
 *   .routine-steps--loading   → show dots, fade steps (both mobile + desktop)
 *   .routine-steps--expanded  → expanded layout with skeleton cards
 *   .routine-steps--revealed  → skeletons out, real product cards in
 *
 * Collapse button reverses the state.
 * Respects prefers-reduced-motion via CSS.
 */
(function () {
  'use strict';

  var expandBtn = document.querySelector('.routine-expand-btn');
  var stepsContainer = document.querySelector('.routine-steps');
  if (!expandBtn || !stepsContainer) return;

  var collapseBtn = document.querySelector('.routine-collapse-btn');
  var isExpanded = false;

  function isDesktop() {
    return window.innerWidth > 768;
  }

  /* ── Expand ── */
  expandBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (isExpanded) return;

    if (isDesktop()) {
      /* Desktop: loading dots (1.5s) → skeleton (1.2s) → reveal */
      stepsContainer.classList.add('routine-steps--loading');
      setTimeout(function () {
        stepsContainer.classList.remove('routine-steps--loading');
        stepsContainer.classList.add('routine-steps--expanded');
        isExpanded = true;
        setTimeout(function () {
          stepsContainer.classList.add('routine-steps--revealed');
        }, 1200);
      }, 1500);
    } else {
      /* Mobile: full 3-phase animation */
      stepsContainer.classList.add('routine-steps--loading');
      setTimeout(function () {
        stepsContainer.classList.remove('routine-steps--loading');
        stepsContainer.classList.add('routine-steps--expanded');
        isExpanded = true;
        setTimeout(function () {
          stepsContainer.classList.add('routine-steps--revealed');
        }, 1000);
      }, 2000);
    }
  });

  /* ── Add to Cart (delegate) ── */
  var routineSection = stepsContainer.closest('.pdp-routine') || stepsContainer.parentElement;
  routineSection.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.routine-product-add');
    if (!addBtn || addBtn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    var origText = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = '…';

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');

    if (window.addToCart) {
      window.addToCart(fd).then(function () {
        addBtn.textContent = '✓ Hinzugefügt';
        addBtn.classList.add('added');
      }).catch(function () {
        addBtn.textContent = origText;
        addBtn.disabled = false;
      });
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: fd
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        addBtn.textContent = '✓ Hinzugefügt';
        addBtn.classList.add('added');
      }).catch(function () {
        addBtn.textContent = origText;
        addBtn.disabled = false;
      });
    }
  });

  /* ── Collapse ── */
  if (collapseBtn) {
    collapseBtn.addEventListener('click', function (e) {
      e.preventDefault();
      stepsContainer.classList.remove('routine-steps--revealed');
      stepsContainer.classList.remove('routine-steps--expanded');
      isExpanded = false;
    });
  }
})();
